var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, HStack, Text, VStack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import Radio from "../atoms/Radio";
import useResponsive from "../util/useResponsive";
const OnboardingRow = (_a) => {
    var { name, value, content, answerInput, customInput, hasOptionalAnswer = true, onChange, isLongInput } = _a, stackProps = __rest(_a, ["name", "value", "content", "answerInput", "customInput", "hasOptionalAnswer", "onChange", "isLongInput"]);
    const handleChange = (value) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(value === "yes");
    };
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const isLong = isLongInput && isSmallScreen;
    return (_jsxs(VStack, Object.assign({ width: "full", space: 3, p: {
            base: 4,
            md: 6,
        }, borderLeftWidth: 2, borderLeftColor: value ? "error.300" : "transparent" }, stackProps, { children: [_jsxs(HStack, Object.assign({ width: "full", space: 3, alignItems: {
                    base: isLong ? "flex-start" : "center",
                    md: "flex-start",
                }, direction: isLong ? "column" : "row" }, { children: [_jsx(Box, Object.assign({ flex: 1 }, { children: _jsx(Text, Object.assign({ fontSize: "md" }, { children: content })) })), hasOptionalAnswer && (_jsx(HStack, Object.assign({ space: 4 }, { children: _jsxs(Radio.Group, Object.assign({ name: name, flexDirection: "row", value: value ? "yes" : "no", onChange: handleChange, defaultValue: "no" }, { children: [_jsx(Radio, Object.assign({ value: "yes" }, { children: t("yes") })), _jsx(Radio, Object.assign({ value: "no", ml: 4 }, { children: t("no") }))] })) }))), customInput && customInput] })), answerInput && (_jsx(HStack, Object.assign({ width: "full", justifyContent: "flex-start" }, { children: _jsx(Box, Object.assign({ width: { base: "full", md: "1/2" } }, { children: answerInput })) })))] })));
};
export default OnboardingRow;
